export const criticidadeAlta = {
	EMI: {
		ESTUDOS: "Não tem conhecimento sobre o que é estudo prospectivo.",
		REUNIOES: "Não realiza reuniões com a equipe.",
	},
	GGPI: {
		PI:
			"Não gera nada novo que seja passível de proteção junto ao INPI ou não sabe ou não se importa com o registo da PI, incluindo a sua marca.",
		TT:
			"Nunca realizou TT ou tem vitrine tecnológica ou mesmo protegeu tecnologias por patente ou RPC.",
	},
	AIO: {
		ACOES:
			"Mantém os mesmos insumos, variáveis operacionais, etapas, fontes energéticas e os demais recursos naturais dos últimos 2 anos e não estão previstos planos de ação neste sentido.",
		AUTOMACAO:
			"A organização ainda realiza tudo manualmente, exceto nas suas atividades administrativas de rotina, como edição de texto e geração de notas fiscais, o que pode impactar na sua produtividade.",
		MERCADOS:
			"Não realiza ações de marketing ou o faz apenas quando há grande redução nos lucros, bem como não mantem relacionamento com os clientes (exceto o atendimento no momento da aquisição do serviço ou produto).",
	},
	IGC: {
		INVESTIMENTO:
			"Não investe em pesquisa ou busca, constantemente, novos equipamentos para maior produtividade.",
		CAPACITACAO:
			"A capacitação dos funcionários não tem previsão para acontecer ou acontece raramente.",
		INCENTIVO:
			"Nunca houve e não há previsão de incentivos para os funcionários e/ou clientes visando proposição de soluções para gargalos da organização.",
		PARCERIA:
			"Não tem interesse ou já houve parceria(s), mas ocorreu a mais de 3 anos.",
	},
	PG:
		"Gestor tradicional, que não está receptivo a novas ideias ou mudanças.",
};

export const criticidadeMedia = {
	EMI: {
		ESTUDOS:
			"A organização sabe do que se trata estudos prospectivos, porém não realiza ou realiza pouco.",
		REUNIOES:
			"Realiza reuniões apenas com os responsáveis pelo(s) setor(es) para a resolução de problemas, porém não define metas nem planejamentos ou planos de ação",
	},
	GGPI: {
		PI:
			"Possui pedido de registro ou certificado da marca ou pelo menos um registro da PI (patente, RPC ou desenho industrial) ou estabelece meta de lançar pelo menos um novo produto ou melhoria de processo a cada ano. Não dispõe de responsável pela gestão da PI.",
		TT:
			"Dispõe de vitrine tecnológica, tem um funcionário designado especificamente para os processos de TT, mas nunca realizou nenhum processo de TT.",
	},
	AIO: {
		ACOES:
			"Realizou mudanças nos insumos (ou variáveis operacionais ou etapas dos processos) e/ou inseriu fontes alternativas de energia ou outras formas de redução do uso de recursos naturais nos últimos 2 anos. Recomenda-se a elaboração sistemática de planos de ação, contendo metas pré-estabelecidas.",
		AUTOMACAO:
			"A instituição adota certas medidas de digitalização ou automatização de processos, porém ainda incipientes.",
		MERCADOS:
			"Realiza ações de marketing e/ou mantem ações voltadas ao relacionamento futuro com os clientes, porém não elabora modelos de negócios para novos produtos ou serviços.",
	},
	IGC: {
		INVESTIMENTO:
			"Apenas oportunamente ou eventualmente já investiu em (P&D), incluindo a possibilidade de aquisição de novos equipamentos, sem valores pré-definidos",
		CAPACITACAO:
			"A capacitação é incentivada, porém apenas para poucos na organização, tal como os responsáveis pelos setores.",
		INCENTIVO:
			'Apenas "eventualmente" são realizados desafios de ideias (ou ações similares), visando a proposição de soluções para gargalos da organização, com  ou sem premiação para as melhores soluções apresentadas, bem como não há previsão formal de parcentual para os autores para os ganhos auferidos a partir de licenciamento(s) ou cessão (ões) de tecnologias.',
		PARCERIA:
			"Há ou houve parceria(s), nos últimos 3 anos, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico, porém sem  formalização por meio de ACT(s), convênio(s) ou similar(es), nem pedido de proteção de PI gerada.",
	},
	PG:
		"O Gestor até escuta seus colaboradores, porém ainda não atribui prioridade às ações necessárias para implementá-las.",
};

export const criticidadeBaixa = {
	EMI: {
		ESTUDOS:
			"Realiza estudos prospectivos com certa frequência, porém ainda não mantém a sistemática de realização de pelo menos um estudo prospectivo por ano.",
		REUNIOES:
			"Realiza reuniões, apenas eventualmente, para debater com chefes de setores ou colaboradores sobre as ações da instituição para o futuro, estabelecendo meta(s) e elaborando planejamento(s).",
	},
	GGPI: {
		PI:
			"Possui pelo menos um registro da PI e estabelece meta de lançar pelo menos um novo produto ou melhoria de processo a cada ano, porém não dispõe de responsável pela gestão da propriedade intelectual.",
		TT:
			"Dispõe de vitrine tecnológica, tem um funcionário designado especificamente para os processo de TT e já concluiu pelo menos um processo de TT, porém ainda não ocorre frequentemente.",
	},
	AIO: {
		ACOES:
			"Realizou mudanças nos insumos (ou variáveis operacionais ou etapas dos processos), inseriu fontes alternativas de energia ou outras formas de redução do uso de recursos naturais nos últimos 2 anos e tem plano de ação em andamento, porém sem planejamento para futuros planos de ação.",
		AUTOMACAO:
			"A empresa se empenha em automatizar processos, porém ainda não em uma porcentagem avançada.",
		MERCADOS:
			"Eventualmente, realiza ações de marketing, mantem ações voltadas ao relacionamento futuro com os clientes e elabora modelos de negócios para novos produtos ou serviços, porém não de forma sistemática.",
	},
	IGC: {
		INVESTIMENTO:
			"Investe, sistematicamente, recursos sobressalentes a partir da projeção do fluxo de caixa em (P&D), incluindo a possibilidade de aquisição de novos equipamentos, sendo recomendado aumentar o percentual do investimento.",
		CAPACITACAO:
			"A organização incentiva a capacitação dos funcionários, porém sem possibilidade de apoio financeiro ou ajuda de custo.",
		INCENTIVO:
			"Realiza, sistematicamente, desafios de ideias (ou ações similares), visando a proposição de soluções para gargalos da organização, com  ou sem premiação para as melhores soluções apresentadas, porém não há normativo prevendo parcentual para os autores para os ganhos auferidos a partir de licenciamento(s) ou cessão (ões) de tecnologias.",
		PARCERIA:
			"Há ou houve parceria(s), nos últimos 3 anos, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico e formalizada(s) por meio de ACT(s), convênio(s) ou similar(es). Recomenda-se avaliar entrar com pedido(s) de proteção de PI gerada(s).",
	},
	PG:
		"Gestor inovador, que empreende esforços para implementar novas ideias, porém sem experiência.",
};

export const pontosFortes = {
	EMI: {
		ESTUDOS:
			"Perfeito! Mantém a sistemática de realização de pelo menos um estudo prospectivo por ano.",
		REUNIOES:
			"Excelente! Realiza, sistematicamente, reuniões para debater com chefes de setores ou colaboradores sobre as ações da instituição para o futuro, estabelecendo meta(s) e elaborando planejamento(s).",
	},
	GGPI: {
		PI:
			"A organização possui pelo menos um registro de proteção da PI, estabelece meta de lançar pelo menos um novo produto ou melhoria de processo a cada ano e dispõe de responsável pela gestão da propriedade intelectual.",
		TT:
			"Os processos de TT ocorrem frequentemente ou as tecnologias são protegidas por patentes ou RPCs somente com objetivo defensivo.",
	},
	AIO: {
		ACOES:
			"Realizou mudanças nos insumos (ou variáveis operacionais ou etapas dos processos), inseriu fontes alternativas de energia ou outras formas de redução do uso de recursos naturais nos últimos 2 anos, tem plano de ação em andamento, além de planejamento para elaboração de futuros planos de ação.",
		AUTOMACAO:
			"A empresa tem a grande maioria dos seus processos automatizados.",
		MERCADOS:
			"Utiliza métodos de marketing, mantem ações voltadas ao relacionamento futuro com os clientes e elabora modelos de negócios para novos produtos ou serviços.",
	},
	IGC: {
		INVESTIMENTO:
			"Investe, sistematicamente e em quantidade satisfatória, no desenvolvimento de pesquisa e/ou compra de equipamentos.",
		CAPACITACAO:
			"A organização incentiva a capacitação dos funcionários, com possibilidade bolsa ou ajuda de custo.",
		INCENTIVO:
			"Realiza, sistematicamente, desafios de ideias (ou ações similares), com ou sem reconhecimento/premiação (financeira e/ou não financeira) para as melhores soluções apresentadas, além de dispor de normativo prevendo percentual, para o(os) autor(es), dos ganhos auferidos a partir de licenciamento(s) ou cessão (ões) de tecnologia(s).",
		PARCERIA:
			"Há ou houve parceria(s), nos últimos 3 anos, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico, formalizada(s) por meio de ACT(s), convênio(s) ou similar(es) e incluindo pedido de proteção de PI gerada.",
	},
	PG:
		"Gestor inovador, que empreende esforços para implementar novas ideias e tem experiência prévia com inovações.",
};
